import ContactEmailAddressSelector from './containers/ContactEmailAddressSelectorContainer'

export default ContactEmailAddressSelector
